export default "__VITE_ASSET__B8BArZP1__"